module.exports = __webpack_public_path__ + "assets/img/32.3e50697c.png";